import Spin from './Spin'

export { SpinProps } from './Spin'
export default Spin



// WEBPACK FOOTER //
// ./components/spin/index.js